var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("div", { class: [_vm.$mq.phone ? "bg-white" : "bg-gray"] }, [
        _c("section", { staticClass: "container px-1 py-2 p-lg-3" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 p-0" },
              [
                _vm.currentStep === 1 ? _c("booking") : _vm._e(),
                _vm._v(" "),
                _vm.currentStep === 2 ? _c("checkout") : _vm._e()
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.currentStep === 1
        ? [
            _vm.parentServiceId === 1 ? _c("booking-detail") : _vm._e(),
            _vm._v(" "),
            _vm.parentServiceId === 2 ? _c("ironing-service-detail") : _vm._e(),
            _vm._v(" "),
            _vm.parentServiceId === 7 ? _c("massage-service-detail") : _vm._e(),
            _vm._v(" "),
            _vm.parentServiceId === 39
              ? _c("bathroom-cleaning-service-detail")
              : _vm._e(),
            _vm._v(" "),
            _vm.parentServiceId === 35
              ? _c("service-detail")
              : _vm.parentServiceId != 1 &&
                _vm.parentService &&
                _vm.parentService.has_service_items === 1
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-sm-8 offset-sm-2 col-lg-6 offset-lg-3 p-0"
                    },
                    [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-body" }, [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$i18n.locale === "th"
                                  ? _vm.parentService.detail_th
                                  : _vm.parentService.detail_en
                              )
                            }
                          })
                        ])
                      ])
                    ]
                  )
                ])
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e598890", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e598890","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/newSteps/Index.vue
// module id = 1755
// module chunks = 0